var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar-nav',{staticClass:"ml-auto"},_vm._l((_vm.menu),function(route,index){return _c('li',{key:index,staticClass:"list-inline-item"},[_c('router-link',{staticClass:"nav-link chr-nav-link",attrs:{"to":{
      name: route.routeName,
      params: route.routeParams || {}
    }}},[_vm._v(_vm._s(route.label))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }